import { useQuery } from '@tanstack/react-query';
import { getPMV, getPMVPhysicalMetric } from '../pmv';
import { PMVMetricParams } from '../pmv/types';

export function usePmv() {
  return useQuery({
    queryKey: ['pmv'],
    queryFn: () => getPMV(),
    staleTime: 30000, // Consider data fresh for 30 seconds
    retry: (failureCount, error) => {
      // Only retry network errors, not 4xx errors
      if (error.status && error.status >= 400 && error.status < 500) {
        return false;
      }
      return failureCount < 3;
    },
  });
}

export function usePmvMetric(filters: PMVMetricParams) {
  return useQuery({
    queryKey: ['pmv', filters],
    queryFn: () => getPMVPhysicalMetric(filters),
    staleTime: 30000, // Consider data fresh for 30 seconds
    retry: (failureCount, error) => {
      // Only retry network errors, not 4xx errors
      if (error.status && error.status >= 400 && error.status < 500) {
        return false;
      }
      return failureCount < 3;
    },
  });
}